const LULU_BULK_SYNC = {
  BULK_SYNC: "BULK_SYNC",
  BULK_SYNC_SUCCESS: "BULK_SYNC_SUCCESS",
  BULK_SYNC_FAILURE: "BULK_SYNC_FAILURE",
}

export default LULU_BULK_SYNC;